import React, { useEffect, useState, useRef } from "react";
import { Dimensions,Text,TouchableOpacity, View, TextInput,} from "react-native";
import Loader from "../../common/Loader";
import Header from "../../common/Header";
import * as RootNavigation from "../../utilities/RootNavigation";
import CImage from "../../common/CImage";
import CustomButton from "../../common/CustomButton";
import CustomTextInput from "../../common/CustomTextInput";
import useStyles from "./ActivateUser_Styles";
import CustomInput from "../../common/CustomInput";
import LoginTabIcons from "./LoginTabIcons";
import LoginRightWidget from "./LoginRightWidget";
import LoginFooter from "./LoginFooter";
import LoginMoibleContent from "./LoginMobileContent";
import { sendOtp, validateOtp,getEncKey,getCpatcha  } from "../../api/apiManager";
import CountdownTimer from "../../common/CTimer.web";
import CText from "../../common/CText";
import CView from "../../styles/CommonStyle";
import { COLORS } from "../../constant";
import { Encryption as encrypt,decryptCaptcha ,encryptCaptcha} from '../../utilities/Encryption';

const isSmallDevice = Dimensions.get("window").width < 767;

export default function ActivateUser(props) {
  const styles = useStyles();
  const otpPattern = /^\d{6}$/;
  const [userId, setUserId] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [otp, setOtp] = useState("");
  const [otpResponse, setOtpResponse] = useState("");
  const [screenName, setScreenName] = useState("1");
  const counterRef = useRef(null);

  useEffect(()=>{
    generateCaptcha();
  },[])
  const generateCaptcha = () => {
   setCaptcha("")
    getCpatcha()
      .then((res) => {
        decryptCaptcha(res?.data).then((res) => {
          setCaptchaText(res?.captchaCode)
          setCaptchaId(res?.captchaId)
        });
      }).catch((err) => {
        const routeObj = { title: "Captcha", type: "Error", msg: err?.response?.data?.message, btnText: "Ok", navigation: "Login", }
        RootNavigation.navigate("ResponseScreen", { data: routeObj })
      });
  };

  const resendOTP = () => {
    setIsLoading(true);
    setOtp("");

    let reqObj = {
      requestId: otpResponse?.response?.otp,
      type: "actUserWithCaptcha",
      id: userId,
    };
    onSendOtp(reqObj);
  };

  const onValidateOtp = () => {
    setIsLoading(true);
    let reqObj = {
      type: "actUserWithCaptcha",
      otp: otp,
      requestId: otpResponse?.response?.otp,
      userId: userId,
    };

    validateOtp(reqObj)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.statusCode == 200) {
          const routeObj = {
            title: "Activate USer Id",
            type: "success",
            msg: res?.data?.message,
            btnText: "Ok",
            navigation: "Login",
          };
          RootNavigation.navigate("ResponseScreen", { routeObj });
        } else if (res?.data?.statusCode < 0) {
          resetData();
          const routeObj = {
            title: "Activate USer Id",
            type: "Error",
            msg: res?.data?.message,
            btnText: "Ok",
            navigation: "ActivateUser",
          };
          RootNavigation.navigate("ResponseScreen", { routeObj });
          setScreenName("1");
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const resetData = () => {
    setUserId("");
    setCaptcha("");
  };

  const onSendOtp = (reqObj) => {
    sendOtp(reqObj)
      .then((res) => {
        setIsLoading(false);

        if (res?.data?.statusCode == 1003) {
          setScreenName("2");
          setOtpResponse(res?.data);
        } else if (res?.data?.statusCode == -1004) {
          resetData();
          const routeObj = {
            title: "Activate User Id",
            type: "error",
            msg: res?.data?.message,
            btnText: "Ok",
            navigation: "ActivateUser",
          };
          RootNavigation.navigate("ResponseScreen", { routeObj });
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const onClickGetOtp = () => {
    setIsLoading(true);
    getEncKey()
      .then(async (res) => {
        if (res.statusCode == 200) {
          const encKey = res?.data || '';
          const encryptedCaptcha = await encrypt(`${captchaId}:${captcha}`, encKey);
          let reqObj = {
            type: 'actUserWithCaptcha',
            id: userId,
            captcha: encryptedCaptcha,
          };
          onSendOtp(reqObj);
        }
      })
      .catch((err) => {
        const routeObj = { title: 'Login ', type: 'Error', msg: err?.response?.data?.message, btnText: 'Ok', navigation: 'Login' };
        RootNavigation.navigate('ResponseScreen', { data: routeObj });
      });
  };

  const renderActivateUser = () => {
    return (
      <View style={styles.containerBox}>
        <View style={styles.rectangle41}>
          <TouchableOpacity onPress={() => RootNavigation.navigate("SelectUnlockScreen")}>
            <CImage.BackIconWhite></CImage.BackIconWhite>
          </TouchableOpacity>
       
          <CText.loginText  style={{ justifyContent: "center", paddingLeft: 10 }}>
            {"Activate User Id"}
          </CText.loginText>
        </View>
        {screenName == "1" ? (
          <View style={{ width: "100%" }}>
            <View style={styles.contentR} >
              <View style={{ width: "80%" }}>
                {userId.length > 0 ? (
                  <CText.labelStyle
                    style={{
                      position: "absolute",
                      zIndex: 999,
                      top: -5,
                      left: 10,
                      backgroundColor: COLORS.white,
                      paddingHorizontal: 3,
                    }}
                  >
                    {"Enter User ID "}
                  </CText.labelStyle>
                ) : null}

                <CustomTextInput
                  value={userId}
                  placeholder={"Enter User Id"}
                  onChangeText={(t) => {
                    setUserId(t);
                  }}
                  patternDif={/[^A-Za-z0-9.]/g}
                />
                <CImage.InputUserIcon></CImage.InputUserIcon>
              </View>
              <View style={styles.captchaWrapper} >
                <View  style={styles.captchaTextWrapper}>
                  <CText.activeCapchaStyle style={{ paddingLeft: 4 }}>
                    {captchaText}{" "}
                  </CText.activeCapchaStyle>
                </View>
                <View style={styles.captchaInputWidget}>
                  <TextInput
                    value={captcha}
                    onChangeText={(t) => setCaptcha(t.replace(/[^0-9a-zA-Z]+/gi, ''))}
                    placeholder={"Enter captcha code"}
                    style={styles.captchaInputStyle}
                  />
                  <TouchableOpacity
                    onPress={generateCaptcha}
                    style={styles.reloadCaptcha}>
                    <CImage.ReloadCaptchaIcon></CImage.ReloadCaptchaIcon>
                  </TouchableOpacity>
                </View>
              </View>
              <View style={styles.submitBtnWrapper}>
                <CustomButton
                  onPress={captcha === captchaText ? onClickGetOtp : ()=>{}}
                  text={"Submit"}
                  disable={captcha !== captchaText}
                />
              </View>
            </View>
          </View>
        ) : screenName === "2" ? (
          <View style={{ width: "80%", alignSelf: "center" }}>
            <CText.enterOtpDescStyle
              style={{
                lineHeight: 12,
                marginHorizontal: "5%",
                paddingTop: 20,
                opacity: 0.5,
              }}
            >
              {otpResponse?.message}
            </CText.enterOtpDescStyle>
       <CText.enterOtpTxtStyle
              style={{
                marginHorizontal: "10%",
                marginTop: 30,
                marginBottom: 5,
                alignSelf: "center",
                paddingBottom: 5,
              }}
            >
              {"Enter OTP"}
            </CText.enterOtpTxtStyle>

            <CustomInput
              value={otp}
              onValueChanged={(e) => setOtp(e)}
              style={[styles.textInputStyle, { width: 280 }]}
              maxLength={6}
              pattern={/^\d{6}$/}
              errorMessage={"Enter Valid OTP"}
              type="number"
              keyboardType="numeric"
            />
            <View style={styles.resendViewStyle}>
              <CountdownTimer
                requestOtp={screenName == "2"}
                onClickGetOtp={resendOTP}
                counterRef={counterRef}
              />
            </View>
            <View style={styles.btnWidget}>
              <CustomButton
                onPress={!otpPattern.test(otp) ? ()=>{} : onValidateOtp}
                text={"Submit"}
                disable={!otpPattern.test(otp) ? true : false}
              />
            </View>
          </View>
        ) : null}
      </View>
    );
  };

  return (
    <CView W100 HW>
    <CView flex={1}>
        <Header text={"Login"} />
        <View style={styles.bodyContainerStyle}>
        <CView  BG={COLORS.grayOP69} flex={0.4} AC JC >
            {renderActivateUser()}

            <LoginTabIcons />
            </CView>

          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
        <View style={styles.logoWidget} >
        <CView FR>
              <CImage.IDFCLogo></CImage.IDFCLogo>
              </CView>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View style={styles.widgetCenter} >
            {renderActivateUser()}
          </View>

          <LoginMoibleContent />
        </View>

        <LoginFooter />
        </CView>

     <CView>
     {isLoading ? <Loader /> : <></>}
     </CView>
      </CView>
  );
}


